import { render, staticRenderFns } from "./AvatarCropper.vue?vue&type=template&id=fb0a0ee8&scoped=true&"
import script from "./AvatarCropper.vue?vue&type=script&lang=js&"
export * from "./AvatarCropper.vue?vue&type=script&lang=js&"
import style0 from "./AvatarCropper.vue?vue&type=style&index=0&id=fb0a0ee8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0a0ee8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDialog,VHover,VIcon,VImg,VOverlay,VProgressCircular,VRow})
